<div id="transaction-details-section">
    <div class="transaction-details-section-heading">
      <span id="subtitle">{{ pageHeader }}</span>
      <a class="no-print" data-testid="multipleItDetails_editTransactionDetailsLink" (click)="onEditClicked()" *ngIf="!isInrFromTable && !confirmationPagePhase2 && !isOneTimeTotalDist">Edit transaction details</a>
     </div>
    <mm-label-group id="multipleItDetails_transactionType" data-testid="multipleItDetails_transactionType" 
        [title]="labels.transactionType" [data]="transactionTypeLabel">
    </mm-label-group>

    <div class="row">
      <div class="column">
        <mm-label-group id="multipleItDetails_useStandingAuth" data-testid="multipleItDetails_useStandingAuth"
          [title]="labels.useStandingAuth" [data]="useStandingAuth | titlecase">
        </mm-label-group>
      </div>
    
      <div class="column" *ngIf="useStandingAuth === 'yes'">
        <mm-label-group id="multipleItDetails_StandingAuthDetails" data-testid="multipleItDetails_StandingAuthDetails"
          [title]="isBundledStandingAuthTransaction ? labels.bundledStandingAuthDetails : labels.standingAuthDetails"
          [multilineData]="standingAuthDetails">
        </mm-label-group>
      </div>
    </div>

    <div class="row">
      <mm-label-group id="multipleItDetails_frequency" data-testid="multipleItDetails_frequency" 
      [title]="labels.frequency"
      [data]="selectedFrequency"
      class="frequency-column">
      </mm-label-group>
      <mm-label-group *ngIf="isOneTimeTotalDist" id="multipleItDetails_closeAccount" data-testid="multipleItDetails_closeAccount" 
        [title]="labels.closeAccount" 
        [data]="closeAccount"
        class="close-account-column">
      </mm-label-group>
      <mm-label-group *ngIf="isOneTimeTotalDist && closeAccountFieldSelected" id="multipleItDetails_reportsRequested" data-testid="multipleItDetails_reportsRequested" 
        [title]="labels.reportsRequested" 
        [multilineData]="reportsRequested"
        class="reports-requested-column">
      </mm-label-group>
      <mm-tooltip *ngIf="isOneTimeTotalDist && closeAccountFieldSelected" [position]="'left'" [containsLink]="false"
        id="reports-requested-tooltip" data-testid="reports-requested-tooltip">
        <tooltip-content>
          <div>{{reportsRequestedTooltipMsg}}</div>
        </tooltip-content>
        <tooltip-trigger-element>
          <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
        </tooltip-trigger-element>
      </mm-tooltip>
    </div>

    <mm-label-group id="multipleItDetails_transferType" data-testid="multipleItDetails_transferType" 
        [title]="labels.transferType" [data]="formTransferType">
    </mm-label-group>

    <mm-label-group *ngIf="confirmationPagePhase2" id="multipleItDetails_receivingAccount" data-testid="multipleItDetails_receivingAccount" 
      [title]="labels.receivingAccount" [multilineData]="receivingAccountInfo">
    </mm-label-group>

    <div *ngIf="confirmationPagePhase2" class="sdps-row sdps-grid-container sdps-wrap">
      <div *ngIf="classifications.isIra" class = "distReason">
        <mm-label-group id="multipleItDetails_distributionReason" data-testid="multipleItDetails_distributionReason" 
          [title]="labels.distributionReason" [data]="isOneTimeTotalDist ? transactionDetailsInfoTotalDist.distributionReason || '' : transactionDetailsInContext.distributionReason">
        </mm-label-group>        
      </div>
      <div *ngIf="iraToAccountExists && !classifications.isIra" class = "contribType">
        <mm-label-group id="multipleItDetails_contributionType" data-testid="multipleItDetails_contributionType" 
          [title]="labels.contributionType" [data]="isOneTimeTotalDist ? transactionDetailsInfoTotalDist.contributionType || '' : transactionDetailsInContext.contributionType">
        </mm-label-group>
      </div>
      <div *ngIf="displayToAccPTRSFields" class = "toAccountTrust">
        <mm-label-group id="multipleItDetails_trustToIncomePercent" data-testid="multipleItDetails_trustToIncomePercent" 
          [title]="labels.trustIncomePercent" [data]="isOneTimeTotalDist ? transactionDetailsInfoTotalDist.ptrsIncome || '' : toAccountPTRSInfoInContext.trustIncomeToPercent">
        </mm-label-group>        
      </div>
      <div *ngIf="displayToAccPTRSFields" class = "toAccountTrust">
        <mm-label-group id="multipleItDetails_trustToPrincipalPercent" data-testid="multipleItDetails_trustToPrincipalPercent" 
          [title]="labels.trustPrincipalPercent" [data]="isOneTimeTotalDist ? transactionDetailsInfoTotalDist.ptrsPrincipal || '' : toAccountPTRSInfoInContext.trustPrincipalToPercent">
        </mm-label-group>        
      </div>
      <div *ngIf="displayToAccPTRSFields" class = "toAccountTrust">
        <mm-label-group id="multipleItDetails_trustToDepositCode" data-testid="multipleItDetails_trustToDepositCode" 
          [title]="labels.depositTaxCode" [data]="isOneTimeTotalDist ? transactionDetailsInfoTotalDist.ptrsDepositTaxCode || '' : toAccountPTRSInfoInContext.trustDepositCode">
        </mm-label-group>        
      </div>
    </div>

    <div *ngIf="!confirmationPagePhase2 && (iraToAccountExists || classifications.isIra || showToAccountPtrsFields)" id="ToAccountTable" data-testid="ToAccountTable" class="table-container" [ngStyle]='{ width : ToAccountTableWidth }'> 
      <div class="table-row small-padding">
          <sdps-divider class="small-padding" variation="tertiary"></sdps-divider>
            <span class="table-recieving-account-column table-header">Receiving account</span>
            <span *ngIf="classifications.isIra" class="table-distribution-contribution-column table-header">Distribution reason</span> 
            <span *ngIf="iraToAccountExists && !classifications.isIra" class="table-distribution-contribution-column table-header">Contribution type</span>
            <span *ngIf="showToAccountPtrsFields" class="table-ptrs-column table-header">Income</span>
            <span *ngIf="showToAccountPtrsFields" class="table-ptrs-column table-header">Principal</span>
            <span *ngIf="showToAccountPtrsFields" class="table-ptrs-deposit-tax-code-column table-header">Deposit tax code</span>
        </div>
        <div class="break extra-small-padding"></div>
        <div *ngIf="isOneTimeTotalDist">
            <div>
                <div class="table-recieving-account-column">
                    <div>{{transactionDetailsInfoTotalDist.receivingAccount.accountNumber}}</div>
                    <div class="sdps-p-right_large">{{transactionDetailsInfoTotalDist.receivingAccount.accountName}}</div>
                    <div class="grey-text">{{transactionDetailsInfoTotalDist.receivingAccount.accountType}}</div>
                </div>
                <div *ngIf="classifications.isIra" class="table-distribution-contribution-column">{{transactionDetailsInfoTotalDist.distributionReason}}</div> 
                <div *ngIf="iraToAccountExists && !classifications.isIra" class="table-distribution-contribution-column">{{transactionDetailsInfoTotalDist.contributionType}}</div> 
                <div *ngIf="showToAccountPtrsFields" class="table-ptrs-column" data-testid="totalDist_ptrsIncome" >{{transactionDetailsInfoTotalDist.ptrsIncome}}</div> 
                <div *ngIf="showToAccountPtrsFields" class="table-ptrs-column" data-testid="totalDist_ptrsPrincipal">{{transactionDetailsInfoTotalDist.ptrsPrincipal}}</div>
                <div *ngIf="showToAccountPtrsFields" class="table-ptrs-deposit-tax-code-column" data-testid="totalDist_ptrsDepositTaxCode">{{transactionDetailsInfoTotalDist.ptrsDepositTaxCode}}</div>
                <sdps-divider class="small-top-medium-bottom-padding" variation="tertiary"></sdps-divider> 
            </div>
        </div>
        <div *ngIf="!isOneTimeTotalDist">
          <div class="table-row" *ngFor="let transactionDetails of transactionDetailsInfo; let i = index">
              <div>
                  <div class="table-recieving-account-column">
                      <div>{{transactionDetails.receivingAccount.accountNumber}}</div>
                      <div class="sdps-p-right_large">{{transactionDetails.receivingAccount.accountName}}</div>
                      <div class="grey-text">{{transactionDetails.receivingAccount.accountType}}</div>
                  </div>
                  <div *ngIf="classifications.isIra" class="table-distribution-contribution-column">{{transactionDetails.distributionReason}}</div> 
                  <div *ngIf="iraToAccountExists && !classifications.isIra" class="table-distribution-contribution-column">{{transactionDetails.contributionType}}</div> 
                  <div *ngIf="showToAccountPtrsFields" class="table-ptrs-column">{{transactionDetails.ptrsIncome}}</div> 
                  <div *ngIf="showToAccountPtrsFields" class="table-ptrs-column">{{transactionDetails.ptrsPrincipal}}</div>
                  <div *ngIf="showToAccountPtrsFields" class="table-ptrs-deposit-tax-code-column">{{transactionDetails.ptrsDepositTaxCode}}</div>
                  <sdps-divider *ngIf="!(transactionDetailsInfo.length === i+1) && transactionDetailsInfo.length > 1" class="small-padding" variation="tertiary"></sdps-divider>
                  <sdps-divider *ngIf="transactionDetailsInfo.length === i+1" class="small-top-medium-bottom-padding" variation="tertiary"></sdps-divider> 
              </div>
          </div>
        </div>
    </div>

    <mm-label-group *ngIf="this.getProcessDate()" id="multipleItDetails_processDate" data-testid="multipleItDetails_processDate" 
        [title]="labels.processDate" [data]="processDate === 'N/A' ? 'N/A' : processDate | formattedDate">
    </mm-label-group>

    <div class="label-group">
        <span id="nextBusinessDayCopy" data-testid="multipleItDetails_nextBusinessDayCopy">{{nextBusinessDayCopy}}</span>
    </div>

    <div class="table-container">
      <div class="cb-ira-ptrs-fields" *ngIf="costBasis">
        <mm-label-group id="costBasisSelected" data-testid="multipleItDetails_costBasis" [title]="labels.costBasis"
          [data]="costBasis">
        </mm-label-group>
      </div>

      <div class="cb-ira-ptrs-fields" *ngIf="isIraTransaction">
        <mm-label-group id="fedTx" data-testid="fedTx" [title]="labels.federalTax"
          [data]="zeroFedAndStateTax === true ? '0%' : (isOneTimeTotalDist ? fedTaxTotalDist : fedTax)">
        </mm-label-group>
      </div>

      <div class="cb-ira-ptrs-fields" *ngIf="isIraTransaction">
        <mm-label-group id="multipleItDetails_stateTax" data-testid="multipleItDetails_stateTax" [title]="stateTaxLabel"
          [data]="zeroFedAndStateTax === true ? '0%' : (isOneTimeTotalDist ? stateTaxTotalDist : stateTax)">
        </mm-label-group>
      </div>

      <div class="cb-ira-ptrs-fields" *ngIf="(!confirmationPagePhase2 || (confirmationPagePhase2 && isCashAvailableInContext)) && classifications.isPtrs && toAccountCashExists && isNotEmptyOrNull(trustIncomePercent)">
        <mm-label-group id="multipleItDetails_trustIncomePercent" [title]="labels.trustIncomePercent" [data]="trustIncomePercent"
          data-testid="multipleItDetails_trustIncomePercent">
        </mm-label-group>
      </div>
  
      <div class="cb-ira-ptrs-fields" *ngIf="(!confirmationPagePhase2 || (confirmationPagePhase2 && isCashAvailableInContext)) && classifications.isPtrs && toAccountCashExists && isNotEmptyOrNull(trustPrincipalPercent)">
        <mm-label-group id="multipleItDetails_trustPrincipalPercent" [title]="labels.trustPrincipalPercent"
          [data]="trustPrincipalPercent" data-testid="multipleItDetails_trustPrincipalPercent">
        </mm-label-group>
      </div>

      <div class="trust-fields" *ngIf="(!confirmationPagePhase2 || (confirmationPagePhase2 && isCashAvailableInContext)) && classifications.isPtrs && toAccountCashExists && trustTaxCategory && isNotEmptyOrNull(trustTaxCategory)">
        <mm-label-group id="multipleItDetails_trustTaxCategory" [title]="labels.trustTaxCategory"
          [data]="trustTaxCategory | sentenceCase" data-testid="MultipleItDetails_trustTaxCategory">
        </mm-label-group>
      </div>

      <div class="trust-fields" *ngIf="(!confirmationPagePhase2 || (confirmationPagePhase2 && isCashAvailableInContext)) && classifications.isPtrs && toAccountCashExists && isNotEmptyOrNull(trustTaxCode)">
        <mm-label-group id="multipleItDetails_trustTaxCode" [title]="labels.trustTaxCode" [data]="trustTaxCode | sentenceCase"
          data-testid="MultipleItDetails_trustTaxCode">
        </mm-label-group>
      </div>

      <div class="trust-fields" *ngIf="(!confirmationPagePhase2 || (confirmationPagePhase2 && isCashAvailableInContext)) && classifications.isPtrs && toAccountCashExists && isNotEmptyOrNull(trustPaidFor)">
        <mm-label-group id="multipleItDetails_trustPaidFor" [title]="labels.trustPaidFor" [data]="trustPaidFor | name"
          data-testid="multipleItDetails_trustPaidFor">
        </mm-label-group>
      </div>
    
      <div class="trust-fields" *ngIf="(!confirmationPagePhase2 || (confirmationPagePhase2 && isCashAvailableInContext)) && classifications.isPtrs && displayTrustComment && toAccountCashExists && isNotEmptyOrNull(trustComment)">
        <mm-label-group id="multipleItDetails_trustComment" [title]="labels.trustComment" [data]="trustComment"
          data-testid="multipleItDetails_trustComment">
        </mm-label-group>
      </div>
    </div>

<sdps-divider variation="secondary"></sdps-divider>
<span *ngIf="!confirmationPagePhase2" class="small-top-padding" id="subtitle">Transfer totals</span>
<div *ngIf="!confirmationPagePhase2" id=TransferTable class="table-container" [ngStyle]='{ width : TransferTableWidth }'> 
    <div class="table-row small-padding">
        <span class="table-recieving-account-column table-header">Receiving account</span>
        <span class="table-monetary-value-column table-header">Est mkt val. of positions</span>
        <span *ngIf="showTransferTotalsCash" [ngClass]="{'table-total-msg-column': isOneTimeTotalDist, 'table-header': true, 'table-monetary-value-column': !isOneTimeTotalDist}">Cash to receive</span>
        <span *ngIf="showTransferTotalsCash" [ngClass]="{'table-total-msg-column': isOneTimeTotalDist, 'table-header': true, 'table-monetary-value-column': !isOneTimeTotalDist}">Est total to receive</span>
        <span *ngIf="isInitRelease && this.transferType != 'positions' && !isOneTimeTotalDist" class="table-recieving-account-column table-header total-to-receive-column">Total to receive</span>
    </div>
    <div class="break extra-small-padding"></div>
    <div class="table-row" *ngIf="isOneTimeTotalDist" id="multipleItDetails_transferTotal_totalDist" data-testid="multipleItDetails_transferTotal_totalDist">
      <div>
          <div class="table-recieving-account-column">
              <div>{{transactionDetailsInfoTotalDist.receivingAccount.accountNumber}}</div>
              <div>{{transactionDetailsInfoTotalDist.receivingAccount.accountName}}</div>
              <div class="grey-text">{{transactionDetailsInfoTotalDist.receivingAccount.accountType}}</div>
          </div>
          <div class="table-monetary-value-column">{{emvTotalDist}}</div> 
          <div *ngIf="showTransferTotalsCash" class="table-total-msg-column">Total cash balance will be distributed</div>
          <div *ngIf="showTransferTotalsCash" class="table-total-msg-column"> Total account balance will be distributed </div>
      </div>
    </div>
  <div *ngIf="!isOneTimeTotalDist" id="multipleItDetails_transferTotal" data-testid="multipleItDetails_transferTotal">
    <div class="table-row" *ngFor="let toAccountTotal of transferTotal; let i = index">
        <div>
            <div class="table-recieving-account-column">
                <div>{{toAccountTotal.receivingAccount.accountNumber}}</div>
                <div>{{toAccountTotal.receivingAccount.accountName}}</div>
                <div class="grey-text">{{toAccountTotal.receivingAccount.accountType}}</div>
            </div>
            <div class="table-monetary-value-column">{{toAccountTotal.positionTotatValue}}</div>
            <div *ngIf="showTransferTotalsCash" class="table-monetary-value-column">{{toAccountTotal.cashTotalValue}}</div>
            <div *ngIf="showTransferTotalsCash" class="table-monetary-value-column"> {{sumTotals([toAccountTotal.positionTotatValue, toAccountTotal.cashTotalValue])}} </div>
            <div *ngIf="isInitRelease && this.transferType != 'positions'" class="table-recieving-account-column total-to-receive-column">{{totalToReceiveVerbiage}}</div>
            <sdps-divider *ngIf="!(transferTotal.length === i+1) && transferTotal.length > 1" class="small-padding" variation="tertiary"></sdps-divider>
            <sdps-divider *ngIf="transferTotal.length === i+1 && transferTotal.length > 1" class="small-padding" variation="primary"></sdps-divider>
        </div>
    </div>
  </div>
    <div *ngIf="transferTotal.length > 1" class="table-row small-padding">
        <span class="table-total-recieving-account-column">Totals</span>
        <span class="table-total-monetary-value-column">{{toAccountsPositionsTotal()}}</span>
        <span *ngIf="showTransferTotalsCash" class="table-total-monetary-value-column">{{toAccountsCashTotal()}}</span>
        <span *ngIf="showTransferTotalsCash"
            class="table-total-monetary-value-column">{{toAccountsTotalToRecieve()}}</span>
    </div>
</div>
